import { useState } from 'react';
import OffButtonForm from './OffButtonForm';
import useOffButtonForm from './useOffButtonForm';
import ConfirmationDialog from '../../../../../components/dialog/ConfirmationDialog';
import { filterUndefined } from '../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  options: [],
  confirmTitle: '',
  confirmContent: '',
  serviceFunction: () => {},
};

const SettingOffButtonForm = (p) => {
  const {
    label,
    options,
    attributeNameToSave,
    confirmTitle,
    confirmContent,
    serviceFunction,
    ...rest
  } = { ...defaultProps, ...filterUndefined(p) };
  const { loading, value, handleOnClick } = useOffButtonForm(label, serviceFunction);
  const [open, setOpen] = useState(false);

  return (
    <>
      <OffButtonForm
        {...rest}
        label={label}
        options={options}
        loading={loading}
        value={value}
        handleOnClick={() => {
          setOpen(true);
        }}
      />
      {open && (
        <ConfirmationDialog
          open={open}
          title={confirmTitle}
          contentText={confirmContent}
          confirmLabel='Yes'
          cancelLabel='No'
          onConfirm={() => {
            setOpen(false);
            handleOnClick({
              [attributeNameToSave]: value,
            });
          }}
          onCancel={() => { setOpen(false); }}
        />
      )}
    </>
  );
};

export default SettingOffButtonForm;
